export enum ProductName {
  STAR = 'star',
  STARV4 = 'starv4',
  STARV5 = 'starv5',
  AURA = 'aura',
  ANTARES = 'antares',
}
